import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import React from "react";
import { deleteSurveyCategory } from "services/category";
import { toastMessage } from "utils/toastMessage";

const DeleteSurveyCategory = ({
  selectedCategoryDetail,
  onClose,
  setCategoryList,
  surveyCategoryListHandler,
  deleteModel,
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");

  // survey delete handler
  const surveyDeleteHandler = async () => {
    try {
      setButtonLoader(true);
      const { data: responseData, status } = await deleteSurveyCategory({
        _id: selectedCategoryDetail._id,
      });
      if (status === 200) {
        surveyCategoryListHandler()
        onClose();
        toastMessage(responseData.message, "success", "deleteSurveyCategory");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModel}
        handleClose={onClose}
        content="Are you sure you want to Delete this survey Category?"
        title="Delete Survey Category"
        buttonLoader={buttonLoader}
        action={surveyDeleteHandler}
      />
    </>
  );
};

export default DeleteSurveyCategory;
